import Image1 from '../../assets/project1.jpg';
import Image2 from '../../assets/project2.jpg';
import Image3 from '../../assets/project3.jpg';
import Image4 from '../../assets/project4.jpg';
import Image5 from '../../assets/project5.jpg';
import Image6 from '../../assets/project6.jpg';
// import Image7 from '../../assets/project7.jpg';
// import Image8 from '../../assets/project8.jpg';
// import Image9 from '../../assets/project9.jpg';

const data = [
    {
        id: 1,
        category: 'uiux',
        image: Image1,
        title: 'Unveiled Interios (UIUX)',
        desc: 'An UIUX project for a Construction and Renovation Company. The UI is made uisng HTML, CSS and Javascript. This UI is responsive to all the screen sizes be it a tablet or a mobile phone.',
        demo: 'https://unveiled-interiors.netlify.app/',
        github: 'https://github.com/Bidyut163/Unveiled-Interiors',
    },
    {
        id: 2,
        category: 'react',
        image: Image2,
        title: 'Comfy (React/Redux)',
        desc: 'Comfy is an Ecommerce Company for Home Decodation Products. The frontend is built using React and Redux while backend is made using strapy. Use below links to see the demo of the project.',
        demo: 'https://comfy-ul.netlify.app/',
        github: 'https://github.com/Bidyut163/comfy',
    },
    {
        id: 3,
        category: 'uiux',
        image: Image3,
        title: 'Omnifood (UIUX)',
        desc: 'An UIUX project for a food start up company which delivers food to your door every single day. The UI is built using custom CSS with cutting edge CSS tech like CSS grid. UI is fully responsive.',
        demo: 'https://omnifood-ul.netlify.app/',
        github: 'https://github.com/Bidyut163/Omnifood',
    },
    {
        id: 4,
        category: 'react',
        image: Image4,
        title: 'Booktech (React)',
        desc: 'Booktech is an Ecommerce Company that sells books. The frontend is coded using ReactJS using the context api while design is done with Tailwind Css. The site is fully responsive.',
        demo: 'https://booktech-react.netlify.app/',
        github: 'https://github.com/Bidyut163/booktech',
    },
    {
        id: 5,
        category: 'MERN',
        image: Image5,
        title: 'Devconnector (MERN)',
        desc: 'Devconnector is social networking site for developers where developer can connect with their peers all over the world. It is a full stack project built using MERN stack technology. ',
        demo: 'https://devconnector-mern.netlify.app/',
        github: 'https://github.com/Bidyut163/devconnector',
    },
    {
        id: 6,
        category: 'MERN',
        image: Image6,
        title: 'Areatappeal (MERN)',
        desc: 'Areatappeal is a e-filing app for Assam Real Estate Appellate Tribunal based in Guwahati Assam, where appellants can file Appeals.The processing of the appeal is done by officals on the backend.',
        demo: 'https://efiling-appeal.netlify.app/',
        github: 'https://github.com/Bidyut163/efiling-appeal-dev',
    },
    // {
    //     id: 7,
    //     category: 'frontend',
    //     image: Image7,
    //     title: 'Project Title Seven (Frontend)',
    //     desc: 'Provident similique accusantium nemo autem. Veritatis obcaecati tenetur iure eius earum ut molestias architecto voluptate aliquam nihil, eveniet aliquid culpa officia aut!',
    //     demo: 'http://egatortutorials.com',
    //     github: 'https://github.com/egattor',
    // },
    // {
    //     id: 8,
    //     category: 'backend',
    //     image: Image8,
    //     title: 'Project Title Eight (Backend)',
    //     desc: 'Provident similique accusantium nemo autem. Veritatis obcaecati tenetur iure eius earum ut molestias architecto voluptate aliquam nihil, eveniet aliquid culpa officia aut!',
    //     demo: 'http://egatortutorials.com',
    //     github: 'https://github.com/egattor',
    // },
    // {
    //     id: 9,
    //     category: 'frontend',
    //     image: Image9,
    //     title: 'Project Title Nine (Frontend)',
    //     desc: 'Provident similique accusantium nemo autem. Veritatis obcaecati tenetur iure eius earum ut molestias architecto voluptate aliquam nihil, eveniet aliquid culpa officia aut!',
    //     demo: 'http://egatortutorials.com',
    //     github: 'https://github.com/egattor',
    // },
];

export default data;
